import { render } from "./page-read.vue?vue&type=template&id=19c52260&scoped=true"
import script from "./page-read.vue?vue&type=script&lang=js"
export * from "./page-read.vue?vue&type=script&lang=js"

import "./page-read.vue?vue&type=style&index=0&id=19c52260&scoped=true&lang=css"

import exportComponent from "D:\\project\\BahteraAdhiguna\\deployment\\ui\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-19c52260"]])

export default __exports__